import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYellowStar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 19,
	viewBox: "0 0 20 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 15.27L16.18 19L14.54 11.97L20 7.24L12.81 6.63L10 0L7.19 6.63L0 7.24L5.46 11.97L3.82 19L10 15.27Z",
		fill: "url(#paint0_linear_5108_9929)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_5108_9929",
		x1: 0,
		y1: 9.5,
		x2: 20,
		y2: 9.5,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#FF9790" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FFB13B"
		})]
	}) })]
});
export { SvgYellowStar as ReactComponent };
